import React, { useState, useCallback } from 'react';
import { DragDropContext } from '@hello-pangea/dnd';
import KanbanColumn from './KanbanColumn';
import { KANBAN_COLUMNS, groupLeadsByColumn, getDropUpdatePayload } from '../../utils/kanbanMapping';
import { updateLead } from '../../utils/api';

function KanbanBoard({ leads, onCardClick, onLeadUpdate }) {
  const [updating, setUpdating] = useState(false);
  const grouped = groupLeadsByColumn(leads);

  const handleDragEnd = useCallback(async (result) => {
    const { draggableId, source, destination } = result;

    // Dropped outside a column or same position
    if (!destination) return;
    if (source.droppableId === destination.droppableId && source.index === destination.index) return;

    // Don't allow concurrent drags while one is in-flight
    if (updating) return;

    const leadId = draggableId;
    const lead = leads.find(l => l._id === leadId);
    if (!lead) return;

    const newColumnId = destination.droppableId;
    const updatePayload = getDropUpdatePayload(newColumnId);

    // Optimistic update: apply changes locally first
    const optimisticLead = { ...lead, ...updatePayload };
    onLeadUpdate(optimisticLead);

    // Persist to API
    setUpdating(true);
    try {
      const result = await updateLead(leadId, updatePayload);
      // Sync API response back to parent
      if (result.lead) {
        onLeadUpdate(result.lead);
      }
    } catch (error) {
      console.error('Failed to update lead after drag:', error);
      // Rollback: restore original lead data
      onLeadUpdate(lead);
    } finally {
      setUpdating(false);
    }
  }, [leads, onLeadUpdate, updating]);

  return (
    <DragDropContext onDragEnd={handleDragEnd}>
      <div className="kanban-board">
        {KANBAN_COLUMNS.map(column => (
          <KanbanColumn
            key={column.id}
            column={column}
            leads={grouped[column.id] || []}
            onCardClick={onCardClick}
          />
        ))}
      </div>
    </DragDropContext>
  );
}

export default KanbanBoard;
